import { useQuery } from '@tanstack/react-query';
import { PublicNoticeQueries, PN_QUERY_KEYS } from '@api/services/public-notices';
import { ModalContent } from '@components/modal';
import { useModal } from '@stores';
import ModalLoader from '@components/loader/ModalLoader';

import PublicNoticeComment from './PublicNoticeComment';
import '../publicNotices.scss';

const PublicNoticeCommentModal = ({ publicNoticeId }) => {
  const { closeModal } = useModal();
  const { data, isLoading } = useQuery({
    queryKey: [PN_QUERY_KEYS.GET_BY_ID, publicNoticeId],
    queryFn: () => PublicNoticeQueries.getById(publicNoticeId),
  });

  if (isLoading) {
    return <ModalLoader title='Public Notice' />;
  }

  return (
    <ModalContent title='Submit Public Notice Comments' hasCloseButton={false}>
      <PublicNoticeComment isLoading={isLoading} publicNoticeData={data} onClose={closeModal} />
    </ModalContent>
  );
};

export default PublicNoticeCommentModal;
